<script setup lang="ts">
import DreamaLoginLogo from '@/components/dreama-login-logo'
import FeedGrid from '@/components/distribute-feed-grid'
import { useDistributeFeed } from '@/composables/useDistributeFeed'
import { useRouteRefreshSignal } from '@/composables/useRouteRefreshSignal'
import { useUserStore, type UserInfo } from '@/stores/user'
import { loginWithBlankClose } from '@/utils/login'

const { items, loadingInitial, loadingMore, error, hasNext, isLoggedIn, refresh, fetchNext } =
  useDistributeFeed()
const userStore = useUserStore()

useRouteRefreshSignal('discover', refresh)

async function handleLogin() {
  const userInfo = await loginWithBlankClose({
    logo: DreamaLoginLogo,
  })

  if (userInfo) {
    userStore.setUserInfo(userInfo as unknown as UserInfo)
  }
}
</script>

<template>
  <section class="discover-page">
    <FeedGrid
      :items="items"
      :loading-initial="loadingInitial"
      :loading-more="loadingMore"
      :error="error"
      :has-next="hasNext"
      :require-login-on-card-click="!isLoggedIn"
      :show-login-prompt="!isLoggedIn && items.length > 0"
      @load-more="fetchNext"
      @login="handleLogin"
      @retry="refresh"
    />
  </section>
</template>

<style scoped>
.discover-page {
  min-width: 0;
}
</style>
